import React, { FC, Fragment, ReactElement } from 'react';
import { Card, CardActions, CardContent, CardHeader, IconButton, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Deviation, DeviationAction } from 'models/deviations';

type CardInformationProps = {
    title: string;
    subHeader: string;
    content: string;
    icon: ReactElement;
    deviation?: Deviation;
    deviationAction?: DeviationAction;
    onOpenUpdateModal: (deviation: Deviation) => void;
    onOpenConfirmDialog: (deviationId: string) => void;
    versionCheck: boolean;
    dataTest?: string;
};

const CardInformation: FC<CardInformationProps> = ({
    title,
    subHeader,
    content,
    icon,
    deviation,
    deviationAction,
    onOpenUpdateModal,
    onOpenConfirmDialog,
    versionCheck,
    dataTest,
}: CardInformationProps) => {
    const handleEditModal = () => {
        onOpenUpdateModal((deviation as Deviation) || (deviationAction as DeviationAction));
    };

    const handleDeleteModal = () => {
        onOpenConfirmDialog((deviation?._id as string) || (deviationAction?._id as string));
    };

    return (
        <Card variant="outlined" square sx={{ marginBottom: 1 }}>
            <CardHeader
                avatar={icon}
                action={
                    versionCheck ? (
                        <Fragment>
                            <IconButton
                                onClick={() => handleDeleteModal()}
                                data-test={dataTest ? `${dataTest}.delete-btn` : 'card-information.delete-btn'}
                            >
                                <DeleteIcon />
                            </IconButton>
                            <IconButton
                                onClick={() => handleEditModal()}
                                data-test={dataTest ? `${dataTest}.edit-btn` : 'card-information.edit-btn'}
                            >
                                <EditIcon />
                            </IconButton>
                        </Fragment>
                    ) : undefined
                }
                title={<Typography variant="h4">{title}</Typography>}
                subheader={subHeader}
            />
            <CardContent>
                <Typography variant="body2" dangerouslySetInnerHTML={{ __html: content }}></Typography>
            </CardContent>
            <CardActions disableSpacing></CardActions>
        </Card>
    );
};

export default CardInformation;
